import React from "react";

const EndGameSummaryTable = ({ rows = [] }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <div className="endgame-table">
      <div className="endgame-table-header">
        <div>Place</div>
        <div>Player</div>
        <div>Cash</div>
        <div>Net Worth</div>
        <div>Stocks</div>
        <div>💵 Biggest Sell</div>
        <div>📈 Biggest Gain</div>
      </div>
      <div className="endgame-table-body">
        {rows.map((row) => (
          <div key={row.name} className="endgame-table-row">
            <div className="endgame-place">
              {row.position}
            </div>
            <div className="endgame-player">
              <div
                className="endgame-avatar"
                style={{ backgroundColor: row.color || "var(--color-gray-200)" }}
              >
                {row.emoji || "🙂"}
              </div>
              <span className="endgame-name">{row.name}</span>
            </div>
            <div className="endgame-cash">
              ${row.cash ?? 0}
            </div>
            <div className="endgame-networth">
              ${row.netWorth ?? 0}
            </div>
            <div className="endgame-stockcount">
              {row.stockCount ?? 0}
            </div>
            <div className="endgame-stat">
              ${row.biggestSell ?? 0}
            </div>
            <div className="endgame-stat">
              ${row.biggestGain ?? 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EndGameSummaryTable;

